export const realtorData = {
  email: 'carvalpropiedades@unne.cl',
  phone:'933730414'
  // email: 'contacto@accionpanal.com',
};
